// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"963611fd","787":"2204a1c4"}[chunkId] + ".chunk.js";
};